"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConfigurationModel = exports.configurationModelUseableDef = exports.SpecialStartPoint = exports.CONFIGURATION_LEITUNG_MAX = exports.isConfigurationChildRelationEspool = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
function isConfigurationChildRelationEspool(cr) {
    const espoolRelation = cr;
    return !!(espoolRelation === null || espoolRelation === void 0 ? void 0 : espoolRelation.Position) && espoolRelation.Position in echain_shared_articles_1.EspoolChainPosition;
}
exports.isConfigurationChildRelationEspool = isConfigurationChildRelationEspool;
exports.CONFIGURATION_LEITUNG_MAX = 200;
// Special startpoint of configuration
var SpecialStartPoint;
(function (SpecialStartPoint) {
    SpecialStartPoint["meterkette"] = "meterkette";
})(SpecialStartPoint = exports.SpecialStartPoint || (exports.SpecialStartPoint = {}));
// @ts-ignore
exports.configurationModelUseableDef = {
    parent: undefined,
    validation: {
        AEs: true,
        AverageEnvironmentTemperatur: true,
        DomainVersion: true,
        FileRefs: true,
        Fuehrungsrinnen: true,
        IAs: true,
        IaArrangement: true,
        IsAlienConfiguration: true,
        IsIgnoreSafetyDistance: true,
        IsStackingOfLeitungenAllowed: true,
        IgusGUIds: true,
        Konfektionierungen: true,
        Leitungen: true,
        LeitungBomBehavior: true,
        MontBes: true,
        MontageSets: true,
        PdfRefs: true,
        QuoteCount: true,
        UseSameIAColorAndMaterial: true,
        Verpackungen: true,
        Zugentlastungen: true,
    },
};
exports.isConfigurationModel = echain_shared_modelling_1.UseableUtil.createGuard(exports.configurationModelUseableDef);
//# sourceMappingURL=ConfigurationModel.js.map